import React, { Component } from 'react';
import './WarningModal.css'

class WarningModal extends React.Component {
    render() {

        return (
            <section className='modal'>
                
                <div className="container mt-3 fixed-top">
                    <div className="row">
                        <div className="col-md-6 col-sm-12">
                            <div className="alert fade alert-simple alert-warning alert-dismissible text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show" role="alert" data-brk-library="component__alert">
                                <button type="button" className="close font__size-18" data-dismiss="alert">
                                    <span aria-hidden="true">
                                        <i className="fa fa-times warning"></i>
                                    </span>
                                    <span className="sr-only">Close</span>
                                </button>
                                <i className="start-icon fa fa-exclamation-triangle faa-flash animated"></i>
                                Please connect to Ethereum 
                                <strong className="font__weight-semibold"> Rinkeby!</strong> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default WarningModal;